module.exports = __webpack_public_path__ + "img/phones.059c5ac6.gif";